module.exports = __webpack_public_path__ + "img/fa-address-card.96a2fb47.svg";